"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var service_service_1 = require("src/app/Services/service.service");
var core_1 = require("@angular/core");
var ConversationComponent = /** @class */ (function () {
    function ConversationComponent(service, route) {
        this.service = service;
        this.route = route;
        this.activeConversationId = this.route.snapshot.paramMap.get('id');
        service.pageName = "Inbox";
    }
    ConversationComponent.prototype.ngOnInit = function () {
    };
    return ConversationComponent;
}());
exports.ConversationComponent = ConversationComponent;
